import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './PiePagina.module.css';
import logoWebp from '../../recursos/imagenes/logo.webp';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const contactPhone = '+502 3097 8165';
  const contactEmail = 'info@seima.com.gt';
  const whatsappMsg = encodeURIComponent('Hola SEIMA, me interesa solicitar una cotización.');
  const whatsappUrl = `https://wa.me/50230978165?text=${whatsappMsg}`;
  const navigate = useNavigate();

  const handleScrollTo = (id) => {
    if (window.location.pathname === '/') {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={`${styles.footerContainer} container`}>
        {/* Column 1: Info and Brand */}
        <div className={styles.footerCol}>
          <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img src={logoWebp} alt="SEIMA Logo" className={styles.footerLogo} />
          </Link>
          <p className={styles.footerDesc}>
            SEIMA es líder en el suministro y mantenimiento de equipos industriales de lavandería, atendiendo sectores comerciales, hospitalarios y hoteleros con eficiencia de nivel premium y soporte técnico.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div className={styles.footerCol}>
          <h3 className={styles.colTitle}>Enlaces Rápidos</h3>
          <ul className={styles.colList}>
            <li><Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={styles.colLink}>Inicio</Link></li>
            <li><Link to="/nosotros" className={styles.colLink}>Nosotros</Link></li>
            <li><a href="#services" onClick={(e) => { e.preventDefault(); handleScrollTo('services'); }} className={styles.colLink}>Servicios</a></li>
            <li><a href="#products" onClick={(e) => { e.preventDefault(); handleScrollTo('products'); }} className={styles.colLink}>Productos</a></li>
            <li><Link to="/proyectos" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={styles.colLink}>Proyectos</Link></li>
            <li><a href="#location" onClick={(e) => { e.preventDefault(); handleScrollTo('location'); }} className={styles.colLink}>Ubicación</a></li>
            <li><Link to="/preguntas-frecuentes" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={styles.colLink}>FAQ</Link></li>
            <li><a href="#contact" onClick={(e) => { e.preventDefault(); handleScrollTo('contact'); }} className={styles.colLink}>Contacto</a></li>
          </ul>
        </div>

        {/* Column 3: Contact Info */}
        <div className={styles.footerCol}>
          <h3 className={styles.colTitle}>Contacto</h3>
          <ul className={styles.contactList}>
            <li className={styles.contactItem}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.824-1.806-5.194-4.177-7-7l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
              </svg>
              <a href={`tel:${contactPhone}`} className={styles.contactLink}>{contactPhone}</a>
            </li>
            <li className={styles.contactItem}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
              <a href={`mailto:${contactEmail}`} className={styles.contactLink}>{contactEmail}</a>
            </li>
            <li className={styles.contactItem}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
              </svg>
              <span className={styles.contactText}>Blvd. los Próceres 19-08, Cdad. de Guatemala.</span>
            </li>
          </ul>
        </div>

        {/* Column 4: Social Media */}
        <div className={styles.footerCol}>
          <h3 className={styles.colTitle}>Redes Sociales</h3>
          <p className={styles.socialText}>Sigue nuestras novedades técnicas e industriales.</p>
          <div className={styles.socialIcons}>
            {/* Facebook */}
            <a href="https://www.facebook.com/seimasuministrosgt/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Facebook">
              <svg fill="currentColor" viewBox="0 0 24 24" width="20" height="20">
                <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.75z"/>
              </svg>
            </a>
            {/* Instagram */}
            <a href="https://www.instagram.com/seima_suministrosgt/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Instagram">
              <svg fill="currentColor" viewBox="0 0 24 24" width="20" height="20">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            {/* LinkedIn */}
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="LinkedIn">
              <svg fill="currentColor" viewBox="0 0 24 24" width="20" height="20">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.779-1.75-1.75s.784-1.75 1.75-1.75 1.75.779 1.75 1.75-.784 1.75-1.75 1.75zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
            {/* WhatsApp */}
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="WhatsApp">
              <svg fill="currentColor" viewBox="0 0 24 24" width="20" height="20">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className={styles.bottomBar}>
        <div className={`${styles.bottomContainer} container`}>
          <p>© {currentYear} SEIMA. Todos los derechos reservados.</p>
          <div className={styles.legalLinks}>
            <Link to="/aviso-de-privacidad" className={styles.legalLink}>Aviso de Privacidad</Link>
            <span className={styles.legalSeparator}>·</span>
            <Link to="/terminos-y-condiciones" className={styles.legalLink}>Términos y Condiciones</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
